import React from 'react';
import { Navigate } from 'react-router-dom';
import { isPlatformAdmin, readProfile } from '../../utils/platformRoles';

/** UX gate only. The API must still authorize every admin request. */
const AdminRoute = ({ element }) => {
  const profile = readProfile();
  if (!profile) return <Navigate to="/login" replace />;
  if (!isPlatformAdmin(profile)) return <Navigate to="/library" replace />;
  return element;
};

export default AdminRoute;
